import React, {useRef, useState, useEffect, useCallback} from 'react';
import {Turnstile} from '@marsidev/react-turnstile';
import {NODE_ROUTE_URI} from "../../Utils/apiUrl";
import axios from "axios";
import {Box, CircularProgress, Typography} from '@mui/material';
import {useTheme} from "@mui/material/styles";
import {useParams} from "react-router-dom";
import {getI18nContent} from "../../config/i18nConfig";

const CloudflareTurnstile = ({children}) => {

    const theme = useTheme();

    const {lng} = useParams();

    const uiText = getI18nContent(lng, 'captcha');

    const [token, setToken] = useState(null);
    const [isVerified, setIsVerified] = useState(false);
    const [loading, setLoading] = useState(false);
    const turnstileRef = useRef(null);

    const handleReset = useCallback(() => {
        setToken(null);
        setIsVerified(false);
        if (turnstileRef.current) {
            turnstileRef.current.reset();
        }
    }, []);

    const verifyCaptcha = useCallback(async (currentToken) => {
        setLoading(true);
        try {
            const requestURL = `${NODE_ROUTE_URI}/captcha/cloudflareTurnstile`;
            const response = await axios.post(requestURL, {token: currentToken});

            if (response.data.success) {
                setIsVerified(true);
            } else {
                handleReset();
            }
        } catch (e) {
            console.error("Cloudflare verification failed", e);
            handleReset();
        } finally {
            setLoading(false);
        }
    }, [handleReset]);

    useEffect(() => {
        if (token && !isVerified) {
            verifyCaptcha(token);
        }
    }, [token, isVerified, verifyCaptcha]);

    if (!isVerified) {
        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{minHeight: '60vh', p: 3}}
            >
                <Typography variant="body1" sx={{mb: 2, color: 'text.secondary'}}>
                    {loading ? uiText.loading : uiText.check}
                </Typography>

                <Turnstile
                    ref={turnstileRef}
                    siteKey="0x4AAAAAACly7WGjgz2p-Cwp"
                    onSuccess={(newToken) => setToken(newToken)}
                    onExpire={handleReset}
                    onError={handleReset}
                />

                {loading && <CircularProgress size={24} sx={{mt: 2}}/>}
            </Box>
        );
    }

    return <>{children}</>;
};

export default CloudflareTurnstile;


// import React, {useRef, useState} from 'react';
// import {Turnstile} from '@marsidev/react-turnstile';
// import {NODE_ROUTE_URI} from "../../Utils/apiUrl";
// import axios from "axios";
//
// const CloudflareTurnstile = ({children}) => {
//     const [token, setToken] = useState(null);
//     const turnstileRef = useRef(null);
//     const [isVerified, setIsVerified] = useState(false);
//
//     const cloudflareCaptcha = async () => {
//         try {
//             let requestURL = `${NODE_ROUTE_URI}/captcha/cloudflareTurnstile`;
//             const data = {
//                 token: token,
//             }
//             const response = await axios({
//                 method: "POST",
//                 url: requestURL,
//                 data: data
//             })
//
//             if (response.data.success) {
//                 setIsVerified(true);
//                 return true;
//             } else {
//                 handleReset();
//                 setIsVerified(false);
//                 return false;
//             }
//
//         } catch (e) {
//
//             handleReset();
//             setIsVerified(false);
//             return false;
//         }
//     }
//
//     const handleReset = () => {
//         setToken(null);
//         if (turnstileRef.current) {
//             turnstileRef.current.reset();
//         }
//     }
//
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!token) {
//             return;
//         }
//
//         const success = await cloudflareCaptcha();
//         if (success) {
//         }
//     };
//
//     console.log("[cloudflareCaptcha] token", token);
//
//
//     if (!isVerified) {
//         return (
//             <form onSubmit={handleSubmit}>
//                 <Turnstile
//                     ref={turnstileRef}
//                     siteKey="0x4AAAAAACly7WGjgz2p-Cwp"
//                     onSuccess={(token) => setToken(token)}
//                     onExpire={() => {
//                         handleReset();
//                     }}
//                     onError={() => {
//                         handleReset();
//                     }}
//                 />
//             </form>
//         );
//     }
//
//     return <>{children}</>;
// };
//
// export default CloudflareTurnstile;